const home = {
  heroTitle: 'Encuentra tu alojamiento perfecto en Urubici',
  heroSubtitle: 'Chalets, cabañas y posadas en Serra Catarinense',
  searchPlaceholder: '¿A dónde quieres ir?',
  checkIn: 'Check-in',
  checkOut: 'Check-out',
  guests: 'Huéspedes',
  searchButton: 'Buscar alojamientos',
  searchButtonShort: 'Buscar',
  featuredLodgings: 'Alojamientos Destacados',
  viewAll: 'Ver todos los alojamientos',
  experiencesSection: 'Experiencias',
  eventsSection: 'Eventos',
  faqTitle: 'Preguntas Frecuentes',
  faqSubtitle: 'Respuestas claras sobre cómo funciona',
  faq: {
    q1: '¿Cómo funciona la consulta de alojamiento?',
    a1: 'Navega por el catálogo curado, elige el alojamiento y contacta directamente por WhatsApp, teléfono o sitio web oficial. La confirmación de la reserva se realiza directamente con el establecimiento.',
    q2: '¿Los precios se actualizan en tiempo real?',
    a2: 'No. El catálogo muestra los alojamientos disponibles. Para valores y disponibilidad exacta, contacta directamente con el establecimiento a través de los canales publicados.',
    q3: '¿Puedo hablar con la central de reservas?',
    a3: 'Sí. Nuestra central está disponible para ayudar con dudas, recomendaciones y soporte en el proceso de elección.',
    q4: '¿El sitio es oficial de la ciudad?',
    a4: 'Reserve Connect es una plataforma integrada al ecosistema municipal, trabajando en colaboración con hoteles locales y el portal oficial de la ciudad.',
  },
  centralSupport: 'Central de Reservas',
  centralSupportDesc: '¿Prefiere hablar con un especialista? Nuestro equipo está listo para ayudar.',
  hero: {
    slide1: {
      title: 'Urubici, el invierno que quieres vivir comienza aquí',
      subtitle: 'Frío de verdad, sierra, naturaleza y los mejores alojamientos curados de la región.',
      cta: 'Buscar alojamientos',
    },
    slide2: {
      title: 'Reserva con seguridad y elige con confianza',
      subtitle: 'Compara opciones, aplica filtros y contacta directamente con los establecimientos.',
      cta: 'Explorar opciones',
    },
    slide3: {
      title: 'Urubici es carretera, sierra y experiencias inolvidables',
      subtitle: 'Punto de motociclistas, naturaleza exuberante y alta demanda en temporadas especiales.',
      cta: 'Ver alojamientos',
    },
    imageAlt: 'Destino turístico {{index}}',
  },
  searchForm: {
    destination: 'Destino',
    guestSingular: 'huésped',
    guestPlural: 'huéspedes',
  },
  catalogMicrocopy: 'Catálogo curado de alojamientos en Urubici. Contacto directo con los establecimientos.',
  trust: {
    item1: { title: 'Establecimientos verificados', subtitle: 'Curaduría del Portal Urubici' },
    item2: { title: 'Información actualizada', subtitle: 'Datos del catálogo oficial' },
    item3: { title: 'Central de reservas', subtitle: 'Soporte para su elección' },
  },
  featured: {
    label: 'Principal',
    subtitle: 'Opciones seleccionadas de la curaduría de Urubici',
    loadingMessage: 'Cargando alojamientos...',
    errorMessage: 'No se pudieron cargar los alojamientos.',
    noResults: 'No se encontraron alojamientos con este filtro.',
    contactAvailable: 'Contacto directo disponible',
    viewDetails: 'Ver detalles',
    filters: ['Todos', 'Hoteles', 'Posadas', 'Casas', 'Chalets', 'Cabañas'],
  },
  eventos: {
    title: 'Eventos y Temporadas',
    subtitle: 'Planifique su viaje para los mejores momentos en Urubici',
    card1: {
      title: 'Temporada de Invierno',
      description: 'Frío de verdad, nieve ocasional y experiencias únicas en la sierra',
      cta: 'Ver alojamientos para el invierno',
    },
    card2: {
      title: 'Encuentro de Motociclistas',
      description: 'Punto tradicional con carreteras escénicas e infraestructura completa',
      cta: 'Alojamientos ideales para motociclistas',
    },
    card3: {
      title: 'Eventos y Festivales',
      description: 'Festivales culturales, gastronómicos y celebraciones locales',
      cta: 'Buscar alojamiento para eventos',
    },
    card4: {
      title: 'Temporadas de Aventura',
      description: 'Senderos, cascadas y naturaleza exuberante todo el año',
      cta: 'Ver alojamientos disponibles',
    },
  },
  explore: {
    title: 'Explore Urubici',
    subtitle: 'Todo lo que necesita saber para planificar su viaje',
    card1: {
      title: 'Qué hacer',
      description: 'Descubra atracciones, paseos y experiencias locales',
    },
    card2: {
      title: 'Mejor época para visitar',
      description: 'Clima, eventos y consejos sobre cuándo viajar',
    },
    card3: {
      title: 'Guía completa de la ciudad',
      description: 'Historia, cultura e información esencial',
    },
  },
  finalCta: {
    title: '¿Listo para vivir Urubici?',
    subtitle: 'Explore nuestro catálogo curado y encuentre el alojamiento perfecto para su viaje.',
    button: 'Ver todos los alojamientos',
  },
};
export default home;
